import React from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import logoimg from "../../assets/images/logo/logo.png";
import img1 from "../../assets/images/tiny-footer/01.png";
import img2 from "../../assets/images/tiny-footer/02.png";
import img3 from "../../assets/images/tiny-footer/03.png";
import img4 from "../../assets/images/tiny-footer/04.png";
import img5 from "../../assets/images/tiny-footer/05.png";

const footer = {
    slidesToShow: 5,
    SlideToScroll: 1,
    Infinity: true,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 2000
}

const Footer = () => {
    return (
        <div>
            <footer>
                <div id="footer-three" className="footer-three-main-block">
                    <div className="container">
                        <div className="row">   
                            <div className="col-lg-4 col-md-4">
                                <div className="footer-three-block">
                                    <div className="footer-three-logo">
                                        <Link to="#" title="">
                                            <img src={logoimg} className="img-fluid" alt="" />
                                        </Link>
                                    </div>
                                    <ul className="footer-three-dtls">
                                        <li>
                                            555 A, East Manster Street, Ready Halley Neon, Uk 4512
                                        </li>
                                        <li>
                                            <Link to="tel:+4733378901" title="">
                                                +00 123 45678 44
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="mailto:Supportinfo@gmail.com" title="">
                                                Supportinfo@gmail.com
                                            </Link>
                                        </li>
                                    </ul>
                                    <ul className="footer-three--social-icons">
                                        <li>
                                            <Link to="https://www.facebook.com/" title="">
                                                <i className="flaticon-facebook" />
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="https://x.com/" title="">
                                                <i className="flaticon-twitter" />
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="https://www.linkedin.com/" title="" />
                                            <i className="flaticon-linkedin" />
                                        </li>
                                        <li>
                                            <Link to="https://www.pinterest.com/" title="">
                                                <i className="flaticon-pinterest" />
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-8 col-md-8">
                                <div className="row">
                                    <div className="col-lg-3 col-md-4">
                                        <div className="footer-three-widget">
                                            <h6 className="footer-three-widget-heading jakarta-font">
                                                Quick Links
                                            </h6>
                                            <ul className="footer-three-menu">
                                                <li>
                                                    <Link to="/" title="">
                                                        Home page
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="/About us" title="">
                                                        About page
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="/Shop" title="">
                                                        Shop Page
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="/Blog-Detail" title="">
                                                        Blog Details
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="/Contact" title="">
                                                        Contacts us
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="/Shop-filter" title="">
                                                        Products
                                                    </Link>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4">
                                        <div className="footer-three-widget">
                                            <h6 className="footer-three-widget-heading jakarta-font">
                                                Our Policy
                                            </h6>
                                            <ul className="footer-three-menu">
                                                <li>
                                                    <Link to="#" title="">
                                                        Privacy Protection
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="#" title="">
                                                        Safe Payments
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="#" title="">
                                                        Terms of Service
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="/Privace$Policy" title="">
                                                        Privacy Policy
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="#" title="">
                                                        Shipping &amp; Returns
                                                    </Link>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-4">
                                        <div className="footer-three-widget">
                                            <h6 className="footer-three-widget-heading jakarta-font">
                                                Get Active <span>Updates</span>
                                            </h6>
                                            <p>
                                                Get Access to the new Styles, workout Secrets,and
                                                Specials offers
                                            </p>
                                            <div className="footer-three-subscribe">
                                                <form>
                                                    <div className="form-floating mb-3">
                                                        <input
                                                            type="email"
                                                            className="form-control"
                                                            id="floatingInput"
                                                            placeholder="name@example.com"
                                                        />
                                                        <label htmlFor="floatingInput">
                                                            Enter Your Email
                                                        </label>
                                                    </div>
                                                    <button type="button" className="btn btn-primary-three">
                                                        Subscribe
                                                    </button>
                                                </form>
                                                <p>By Subscribing to get Special Discount</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="tiny-footer-three-block">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-4 col-md-4">
                                <div className="footer-three-coyright">
                                    Copyright © 2025. All Rights Reserved.
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-4 text-center">
                                <div className="tiny-footer-three-payment-img">
                                    <Slider className="slider tiny-payment-three-autoplay"{...footer}>
                                        <div>
                                            <Link to="/" title="">
                                                <img src={img1} className="img-fluid" alt="" />
                                            </Link>
                                        </div>
                                        <div>
                                            <Link to="/" title="">
                                                <img src={img2} className="img-fluid" alt="" />
                                            </Link>
                                        </div>
                                        <div>
                                            {" "}
                                            <Link to="/" title="">
                                                <img src={img3} className="img-fluid" alt="" />
                                            </Link>
                                        </div>
                                        <div>
                                            <Link to="/" title="">
                                                <img src={img4} className="img-fluid" alt="" />
                                            </Link>
                                        </div>
                                        <div>
                                            <Link to="/" title="">
                                                <img src={img5} className="img-fluid" alt="" />
                                            </Link>
                                        </div>
                                        <div>
                                            <Link to="/" title="">
                                                <img src={img1} className="img-fluid" alt="" />
                                            </Link>
                                        </div>
                                        <div>
                                            <Link to="/" title="">
                                                <img src={img2} className="img-fluid" alt="" />
                                            </Link>
                                        </div>
                                        <div>
                                            {" "}
                                            <Link to="/" title="">
                                                <img src={img3} className="img-fluid" alt="" />
                                            </Link>
                                        </div>
                                        <div>
                                            <Link to="/" title="">
                                                <img src={img4} className="img-fluid" alt="" />
                                            </Link>
                                        </div>
                                        <div>
                                            <Link to="/" title="">
                                                <img src={img5} className="img-fluid" alt="" />
                                            </Link>
                                        </div>
                                    </Slider>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-4">
                                <ul className="tiny-footer-three-menu">
                                    <li>
                                        <Link to="#" title="">
                                            Terms &amp; Conditions
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/Privace$Policy" title="">
                                            Privacy Policy
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default Footer;
